import { render, staticRenderFns } from "./BlackGoldHeader.vue?vue&type=template&id=5aca5d58&"
import script from "./BlackGoldHeader.vue?vue&type=script&lang=js&"
export * from "./BlackGoldHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports